import React, { ErrorInfo } from "react";

import { v4 as UUID } from "uuid";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import storage from "commons/utils/storage";

type State = {
    hasError: boolean;
};

class ErrorBoundary extends React.Component<{
    redirectUrl: string;
    uiReportErrorEndpoint?: string;
}> {
    public state: State = {
        hasError: false,
    };

    static getDerivedStateFromError(error: any) {
        console.error("getDerivedStateFromError", error);

        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // You can also log the error to an error reporting service
        console.error("componentDidCatch", error, errorInfo);

        if (this.props.uiReportErrorEndpoint) {
            fetch(this.props.uiReportErrorEndpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Request-ID": `UI-${UUID()}`,
                },
                body: JSON.stringify({ error: error.toString(), errorInfo: errorInfo }),
            });
        }
    }

    render() {
        const clearStorage = () => {
            storage.removeAll();
        };

        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <GridColumn>
                    <GridItem>
                        <GridRow justifyContent={"center"}>
                            <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                                <h1>Errore generico</h1>
                                <p>
                                    L'applicativo ha riscontrato un problema durante l'esecuzione
                                    della richiesta.
                                    <br />
                                    Clicca "Ritorna alla homepage" per riprovare.
                                </p>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <GridRow justifyContent={"center"}>
                            <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                                <a href={this.props.redirectUrl} onClick={clearStorage}>
                                    Ritorna alla homepage
                                </a>
                            </GridItem>
                        </GridRow>
                    </GridItem>
                </GridColumn>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
